import { useTool } from "@turnaroundfactor/react";
import React from "react";
import Tool from "../Tool";
import leo from "../../assets/leo-hero.png";

const modelSteps = [
	{ step: "Downloading", icon: "fa-download" },
	{ step: "Uploading", icon: "fa-upload" },
	// { step: 'Converting', icon: 'fa-magic'},
	// { step: 'Processing', icon: 'fa-sync'},
	// { step: 'Saving to room', icon: 'fa-save'}
	{ step: "Check Assets", icon: "fa-archive" },
];

export default function Scanner({ peer }) {
	const { status, data } = useTool(peer, {
		name: "Scanner",
	});

	const settings = [{ icon: "fa-cog" }];

	function processData() {
		if (data && data.message) {
			if (
				data.message.includes("Converting") ||
				data.message.includes("Downloading")
			) {
				return (
					<>
						<span className="font-weight-bold text-primary font-italic">
							{data.message}
						</span>
						<div
							className="peer-indicator text-center py-3"
							data-testid="spinner"
							style={{ height: "10px" }}
						>
							<i className="fa fa-spin fa-spinner fa-lg fa-fw" />
						</div>
					</>
				);
			} else {
				return (
					<span className="font-weight-bold text-primary font-italic">
						{data.message}
					</span>
				);
			}
		} else if (data && data.error) {
			return (
				<span className="font-weight-bold text-danger font-italic">
					{data.error}
				</span>
			);
		} else {
			return <span className="font-weight-bold text-success">{status}</span>;
		}
	}

	function progressBar() {
		if (data && data.message) {
			if (data.message.includes("%")) {
				const progress = data.message.split("Progress: ")[1].replace("%", "");
				return (
					<div className="progress w-100" style={{ height: "5px" }}>
						<div
							className="progress-bar bg-success"
							role="progressbar"
							aria-valuenow={progress}
							aria-valuemin="0"
							aria-valuemax="100"
							style={{ width: `${progress}%` }}
						></div>
					</div>
				);
			}
		}
		return <></>;
	}

	return (
		<Tool title={peer.name} settings={settings} uuid={peer.uuid}>
			{status === "connected" ? (
				<>
					<div className="bg-light">
						<p className="text-center font-weight-bold pt-2 mb-0 h6">
							Artec Leo | <span className="text-success">{status}</span>
						</p>
						<div class="card mb-0 w-100 bg-light border-0">
							<div class="row no-gutters">
								<div class="col-md-4 d-flex flex-column justify-content-center">
									<img
										src={leo}
										alt="Artec Leo Scanner"
										className="w-100 h-auto"
									/>
								</div>
								<div class="col-md-8">
									<div class="card-body my-0">
										{data && data.project && (
											<p class="text-weight-bold mb-1">
												Project:{" "}
												<span className="font-italic">{data.project}</span>
											</p>
										)}
										<ul className="list-group card-text">
											{modelSteps.map((item, index) => {
												if (data && data.step && data.step === item.step) {
													return (
														<li
															key={index}
															className="list-group-item p-2 active"
															aria-current="true"
														>
															<i className={`fa fa-solid ${item.icon} pr-2`} />
															{item.step}
														</li>
													);
												} else {
													return (
														<li
															key={index}
															className="list-group-item p-2"
															aria-current="false"
														>
															<i className={`fa fa-solid ${item.icon} pr-2`} />
															{item.step}
														</li>
													);
												}
											})}
										</ul>
									</div>
								</div>
							</div>
						</div>
						{data && (
							<div className="text-center w-100 d-flex flex-column justify-content-center">
								<p className="w-100">
									<span className="d-block">Message:</span> {processData()}
								</p>
							</div>
						)}
					</div>
					{progressBar()}
				</>
			) : (
				<div className="p-4 text-center tool" id="multimeter_main">
					<i className="fa fa-spinner fa-spin fa-2x text-muted"></i>
					<span className="text-muted font-italic d-block text-center small mt-1">
						{status === "pending" ? "Awaiting data..." : "Connecting..."}
					</span>
				</div>
			)}
		</Tool>
	);
}
